export default __webpack_public_path__ + "static/media/loading-horizontal.435dd182.gif";